export const mediaFromLg = '(min-width: 1024px)'
export const mediaToLg = '(max-width: 1023.9px)'
export const mediaFromM = '(min-width: 640px)'
export const mediaToM = '(max-width: 639.9px)'
export const mediaFromXl = '(min-width: 1440px)'
export const mediaToXl = '(max-width : 1440px)'
